<template>
    <div
        class="cp file"
        :class="[type? 'is-'+ type :'', extend? 'is-extend':'']"
    >
        <a
            class="link"
            :title="name"
            @click.prevent.stop="clickFile"
        >{{ name }}</a>
        <a
            v-if="extend"
            class="remove"
            title="刪除"
            @click.prevent.stop="removeFile"
        ></a>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                require: false,
                default: 'link'
            },
            name: {
                type: String,
                require: false,
                default: '檔案'
            },
            extend: {
                type: Boolean,
                require: false,
                default: true,
            },
        },
        methods: {
            removeFile: function(evt){
                this.$emit('removeFile', evt);
            },
            clickFile: function(evt){
                this.$emit('clickFile', evt);
            },
        }
    }
</script>

<style scoped lang="scss">

    .cp.file {
        position: relative;
        display: inline-flex;
        vertical-align: middle;
        margin: 1px;
        max-width: 100%;

        %fileBtn {
            padding: $btnInput_pd $interval-m;
            line-height: $btnInput_lh;
            border-radius: $border-radius;
            transition: $transition;
            background-color: $light;
            cursor: pointer;

            &:hover {
                background-color: $light-gray;
            }
        }

        @each $key, $map in $file-type-map {
            $pic: map-get($map, 'pic');

            &.is-#{$key} {

                .link {

                    &::before {
                        background-image: image-url($pic);
                    }
                }
            }
        }

        &.is-extend {

            .link {
                border-radius: $border-radius 0 0 $border-radius;
            }
        }

        .link {
            @extend %ellipsis;
            @extend %fileBtn;

            &.no-content {

                &::before {
                    content: none;
                }
            }

            &::before {
                $size: 16px;
        
                content: $content;
                display: inline-flex;
                width: $size;
                height: $size;
                margin-right: $interval-s;
                background-repeat: no-repeat;
                background-position: center;
                background-image: image-url('icon_other.png');
                border-radius: $border-radius;
                vertical-align: sub;
            }
        }

        .remove, .other {
            @extend %fileBtn;
            border-left: $border;
            border-left-color: $white;
            border-radius: 0 $border-radius $border-radius 0;

            &::before {
                line-height: 1;
                vertical-align: middle;
                @extend %font-pseudo;
            }
        }

        .remove {
            padding-left: $interval-s;
            padding-right: $interval-s;

            &::before {
                content: '\e5cd';
            }
        }

        .other {

            &::before {
                margin-right: $interval-xs;
            }
        }
    }
</style>
